export enum TemplateTagType {
	NONE,
	NEW,
	EDITED,
	DUPLICATE,
}
